var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"m-l-15",on:{"click":_vm.show_modal}},[_c('i',{staticClass:"icon-refresh"}),_vm._v(" Sugerencias ")])
}
var staticRenderFns = []

export { render, staticRenderFns }